import { render } from "./App.vue?vue&type=template&id=2571f194"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2571f194&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/eventusa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__